/**
 * MVK legal documents — static HTML in `/public/legal` (converted from DOCX for
 * in-app ModalSheet viewing; never link to editable Word files).
 *
 * RU stays at `/legal/*.html`; EN lives under `/legal/en/*.html`.
 * Newsletter / marketing mail uses the advertising consent doc (no separate file).
 */
export const LEGAL_CONSENTS_VERSION = "2026-09-v3";

const LEGAL_BASE = "/legal";

export type LegalUrls = {
  privacyPolicy: string;
  userAgreement: string;
  pdConsent: string;
  advertising: string;
  /** Same document as advertising — MVK exhibition mail / notifications. */
  newsletter: string;
};

export function getLegalUrls(lang?: string | null): LegalUrls {
  const isEn = String(lang || "")
    .toLowerCase()
    .startsWith("en");
  const base = isEn ? `${LEGAL_BASE}/en` : LEGAL_BASE;
  const advertising = `${base}/advertising-consent.html`;
  return {
    privacyPolicy: `${base}/privacy-policy.html`,
    userAgreement: `${base}/user-agreement.html`,
    pdConsent: `${base}/pd-consent.html`,
    advertising,
    newsletter: advertising,
  };
}

/** @deprecated Prefer getLegalUrls(lang) so EN locale opens English docs. */
export const LEGAL_URLS: LegalUrls = getLegalUrls("ru");
